import { viewport } from "../../assets/js/functions";

(function ($) {

    const initializeBlock = function ($block) {
        const $contents = $block.find('.tabs-content'),
            $titles1 = $block.find('.tabs-titles .tabs-title'),
            $titles2 = $block.find('.tabs-full .tabs-title');

        $titles1.add($titles2).click(function () {
            const index = $(this).is($titles1) ? $titles1.index($(this)) : $titles2.index($(this));

            $titles1.each(function (i) {
                if(viewport().width >= 768) {
                    if (i === index) {
                        $(this).addClass('active');
                    } else {
                        $(this).removeClass('active');
                    }
                } else if (i === index) {
                    $(this).toggleClass('active');
                }
            });

            $titles2.each(function (i) {
                if(viewport().width >= 768) {
                    if (i === index) {
                        $(this).addClass('active');
                    } else {
                        $(this).removeClass('active');
                    }
                } else if (i === index) {
                    $(this).toggleClass('active');
                }
            });

            $contents.each(function (i) {
                if(viewport().width >= 768) {
                    if (i === index) {
                        $(this).addClass('active');
                    } else {
                        $(this).removeClass('active');
                    }
                } else if (i === index) {
                    $(this).toggleClass('active');
                }
            });
        });
    }

    $(document).ready(function () {
        $('.block--tabs').each(function () {
            initializeBlock($(this))
        })
    })

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=tabs', initializeBlock)
    }

})(jQuery)
